import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { dependentsApi as API } from '../Apis';
import { ErrorsFlowTypes } from '_core/types/Responses';

export const GetDependentsDocs: IDocs = {
  title: 'GetDependentsInfo',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.getLegalGuardian',
};

const prepareCall = () => API.call.get();

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const errorService = infos?.errorService;
  const userNotFound = infos?.userNotFound;
  const wrongParams = infos?.wrongParams;

  return { userNotFound, errorService, wrongParams };
};

export const GetDependentsMachine = GenericMachine(
  prepareCall,
  {
    docs: GetDependentsDocs,
    definitions: API.definitions,
  },
  {
    handleErrorFlowFinalResponseFunction,
  },
);
